/* eslint-disable no-unused-expressions */
import { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  getMember,
  getProjects,
  getAttendanceIdleMinuteWise,
  getAttendanceIdleMinuteWiseCSV,
} from '../../../redux/MainAction';
import { FaFileCsv } from 'react-icons/fa';
import {downloadExcel } from '../../../helpers/helpers';
import moment from 'moment';
import Select from 'react-select';
import PageLoader from '../../../components/HOC/PageLoader';
import { getExeVersions } from '../../../Constant';
import VersionSelector from '../../VersionManagement/version-selector';

const convertMinutesToHM = (minutes) => {
  if (!minutes || minutes === 0) return '0h : 0m';
  const hours = Math.floor(minutes / 60);
  const mins = Math.trunc(minutes % 60);
  return `${hours}h : ${mins}m`;
};

const AttendanceMinuteWise = () => {
  const dispatch = useDispatch();

  const [version, setVersion] = useState(getExeVersions()[0]?.value);
  const emp = useSelector((state) => state.Webtracker.member);
  const prj = useSelector((state) => state.Webtracker.projects);

  useEffect(() => {
    dispatch(getMember());
    dispatch(getProjects());
  }, []);

  return (
    <AttendanceMinuteWiseVersion
      key={version}
      version={version}
      emp={emp}
      prj={prj}
    >
      <VersionSelector version={version} setVersion={setVersion} />
    </AttendanceMinuteWiseVersion>
  );
};

const AttendanceMinuteWiseVersion = ({ version, children, emp, prj }) => {
  const [apiCalls, setApiCalls] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const dispatch = useDispatch();
  const attendance = useSelector(
    (state) => state?.Webtracker?.reportsAttendanceIdleMinuteWise
  );

  const [showReset, setShowReset] = useState(false);

  const dateNew = new Date();

  const initialFilters = {
    employeeIds: [],
    // projectIds: '',
    date: moment(dateNew).format('YYYY-MM-DD'),
  };
  const [filters, setFilters] = useState(initialFilters);

  const onChangeFilter = (event) => {
    const { name, value } = event.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleEmployeeChange = (selectedOptions) => {
    const selectedIds = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilters((prevFilters) => ({
      ...prevFilters,
      employeeIds: selectedIds,
    }));
  };

  const employeeOptions =
    emp?.rows?.map((member) => ({
      value: member.id,
      label: `${member.firstName} ${member.lastName}`,
    })) || [];

  const dispatchCalls = async (data) => {
    await dispatch(getAttendanceIdleMinuteWise(data, version === '1.1.8'));
  };

  const handleApply = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    // if (filters?.employeeIds?.length === 0) {
    //   toast.error('Please select at least one member to see the reports');
    //   return;
    // }

    setApiCalls(true);

    const payload = {};

    if (filters?.employeeIds?.length > 0) {
      payload.employeeIds = filters.employeeIds;
    }

    if (filters?.projectIds) {
      payload.projectIds = [filters.projectIds];
    }
    if (filters?.date) {
      payload.startDate = filters.date;
      payload.endDate = filters.date;
    }

    await dispatchCalls(payload);
    setShowReset(true);
    setIsLoading(false);
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    await dispatchCalls(initialFilters);

    setShowReset(false);
    setFilters({
      employeeIds: [],
      projectIds: '',
      teamIds: '',
      date: moment(dateNew).format('YYYY-MM-DD'),
    });
    setIsLoading(false);
  };

  async function downloadCSVHandler() {
    const payload = {};
    setIsLoading(true);

    if (filters?.employeeIds?.length > 0) {
      payload.employeeIds = filters.employeeIds;
    }

    if (filters?.projectIds) {
      payload.projectIds = [filters.projectIds];
    }
    if (filters?.date) {
      payload.startDate = filters.date;
      payload.endDate = filters.date;
    }

    const csv = await dispatch(getAttendanceIdleMinuteWiseCSV(payload,true));
    downloadExcel(csv, 'Attendance Report');
    setIsLoading(false);
  }

  const minDate = moment().subtract(30, 'days').format('YYYY-MM-DD');
  const maxDate = moment().format('YYYY-MM-DD');

  return (
    <PageLoader isLoading={isLoading}>
      <AUX>
        <div className="page-content-wrapper">
          <div className="container-fluid">
            <h5 className="text-muted"></h5>
            <div className="row">
              <div className="col-12">
                <div className="row">
                  <div className="col-12">
                    <div className="card m-b-20">
                      <div className="d-flex flex-column card-body">
                        <div
                          className="d-flex justify-content-start align-items-start"
                          style={{ gap: '10px' }}
                        >
                          <p className="text-muted mt-2 text-nowrap">
                            Filter by :
                          </p>

                          <div className="mb-3">
                            <div className="d-flex mb-2">
                              {children}
                              <div className="fillSelect">
                                <i className="mdi mdi-briefcase font-20 fillIcon"></i>
                                <select
                                  className="form-control font-14"
                                  name="projectIds"
                                  value={filters?.projectIds}
                                  onChange={onChangeFilter}
                                >
                                  <option value="">All Projects</option>
                                  {prj?.rows?.map((mems, idx) => (
                                    <option key={idx} value={mems?.id}>
                                      {mems?.name}
                                    </option>
                                  ))}
                                </select>
                              </div>
                              <div className="fillSelect">
                                <input
                                  type="date"
                                  className="form-control font-14"
                                  name="date"
                                  value={filters?.date || ''}
                                  onChange={onChangeFilter}
                                  min={minDate}
                                  max={maxDate}
                                />
                              </div>{' '}
                            </div>

                            <div
                              className="d-flex align-items-start"
                              style={{ gap: '0.8rem' }}
                            >
                              <div className="fillSelect">
                                <i className="mdi mdi-account-multiple-outline font-20 fillIcon"></i>
                                <Select
                                  isMulti
                                  value={employeeOptions.filter((option) =>
                                    filters.employeeIds.includes(option.value)
                                  )}
                                  onChange={handleEmployeeChange}
                                  options={employeeOptions}
                                  placeholder="All Members"
                                  className="react-select-container"
                                  classNamePrefix="react-select"
                                  isClearable
                                  styles={{
                                    control: (provided) => ({
                                      ...provided,
                                      minHeight: '35px',
                                      height: '35px',
                                      fontSize: '14px',
                                      minWidth: '200px',
                                      minWidth: '260px',
                                      border: '1px solid #ced4da',
                                    }),
                                    valueContainer: (provided) => ({
                                      ...provided,
                                      height: '33px',
                                      padding: '0 4px',
                                      overflowY: 'auto',
                                    }),
                                    indicatorsContainer: (provided) => ({
                                      ...provided,
                                      height: '33px',
                                    }),
                                    multiValue: (provided) => ({
                                      ...provided,
                                      backgroundColor: '#e9ecef',
                                    }),
                                    multiValueLabel: (provided) => ({
                                      ...provided,
                                      fontSize: '12px',
                                    }),
                                    indicatorsContainer: (provided) => ({
                                      ...provided,
                                      height: '34px',
                                      padding: '0 4px',
                                    }),
                                  }}
                                />
                              </div>

                              <div className="d-flex" style={{ gap: '10px' }}>
                                <Button
                                  className="d-flex align-items-center justify-content-center"
                                  style={{ padding: '6px 14px' }}
                                  size="sm"
                                  color="primary"
                                  onClick={handleApply}
                                >
                                  <i className="ion-ios7-search font-20"></i>
                                </Button>

                                {showReset ? (
                                  <Button
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ padding: '6px 13px' }}
                                    size="sm"
                                    color="danger"
                                    onClick={handleReset}
                                  >
                                    <i className="mdi mdi-close font-20"></i>
                                  </Button>
                                ) : (
                                  ''
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <span>
                          <b>Note :</b> All records are displayed based on the
                          timezone set by the admin.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card ">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center m-b-20">
                      <div className=""></div>

                      <div className="d-flex">
                        <Button
                          color="success"
                          size="sm"
                          className="mr-2 d-flex align-items-center"
                          onClick={downloadCSVHandler}
                        >
                          <FaFileCsv className="mr-1" /> XLSX
                        </Button>
                      </div>
                    </div>
                    <div style={{ overflowX: 'auto' }}>
                      <table
                        id="datatable"
                        className="table dt-responsive nowrap table-vertical"
                        width="100%"
                        cellSpacing="0"
                      >
                        <thead>
                          <tr>
                            <th className="text-nowrap">Member</th>
                            <th className="text-nowrap">Start Time</th>
                            <th className="text-nowrap">End Time</th>
                            <th className="text-nowrap">Active Time</th>
                            <th className="text-nowrap">Idle Time</th>
                            <th className="text-nowrap">Total Time</th>
                          </tr>
                        </thead>
                        <tbody>
                          {apiCalls ? (
                            attendance?.length > 0 ? (
                              attendance?.map((item, idx) => {
                                return (
                                  <tr key={idx}>
                                    <td>
                                      <div className="text-nowrap">
                                        <span className="border rounded p-1 text-white bg-info text-uppercase">
                                          {item?.employeeName?.charAt(0)}
                                        </span>
                                        <span className="ml-1">
                                          {item?.employeeName}
                                        </span>
                                      </div>
                                    </td>

                                    <td className="text-success">
                                      {moment
                                        .parseZone(item?.dayStartTimeLocal)
                                        .format('h:mm A')}
                                    </td>

                                    <td className="text-success">
                                      {item?.dayEndTimeLocal
                                        ? moment
                                            .parseZone(item?.dayEndTimeLocal)
                                            .format('h:mm A')
                                        : '--'}
                                    </td>

                                    <td className="text-nowrap">
                                      {convertMinutesToHM(
                                        item?.uniqueMinuteCount
                                      )}
                                    </td>

                                    <td className="text-nowrap">
                                      {convertMinutesToHM(
                                        +item?.totalIdleTime / 60
                                      )}
                                    </td>

                                    <td className="text-nowrap">
                                      {convertMinutesToHM(
                                        +item?.uniqueMinuteCount +
                                          item?.totalIdleTime / 60
                                      )}
                                    </td>
                                  </tr>
                                );
                              })
                            ) : (
                              <tr>
                                <td colSpan={7} className="text-center">
                                  No Records Found
                                </td>
                              </tr>
                            )
                          ) : (
                            <tr>
                              <td colSpan={7} className="text-center">
                                Please click on the search button.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AUX>
    </PageLoader>
  );
};

export default AttendanceMinuteWise;
